import React from 'react';

import { BoxedDiv } from 'psims/react/components/layout';
import SubmitTerms from '../shared/submit-terms';
import Textarea from 'psims/react/components/textarea';
import { asString } from 'psims/lib/string';
import { ViewMode } from '../shared/use-view-mode';
import { UseProductionForm } from '../productions-shared/use-production-form';

interface SubmissionProps {
    formCtrl: UseProductionForm;
    viewMode: ViewMode
}

const ProductionSubmit = ({formCtrl, viewMode}: SubmissionProps) => {
    return (
        <BoxedDiv box={{marginV: 4}}>
            <SubmitTerms
                disabled={viewMode !== 'edit'}
                hasAgreed={formCtrl.view.Submit.declaration}
                onHasAgreedChange={formCtrl.updateDeclaration}
                shouldFocusDeclaration={true}
            />

            <BoxedDiv box={{}}>
                <Textarea
                    disabled={formCtrl.view.isDisabled}
                    error={formCtrl.view.Submit.CommentsValidationError?.notification.message}
                    id='comments'
                    label='Comments'
                    onChange={e => formCtrl.updateDataSubmissionComment(e.target.value)}
                    setFocused={formCtrl.view.focusedField === 'comments'}
                    value={asString(formCtrl.view.Submit.comments)}
                />
            </BoxedDiv>

        </BoxedDiv>
    )
}

export default ProductionSubmit;
